import { render, staticRenderFns } from "./ScreenRecord.vue?vue&type=template&id=535c961f&"
import script from "./ScreenRecord.vue?vue&type=script&lang=js&"
export * from "./ScreenRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports